import axios from "axios";

import store from "@/main";
import { SERVER_API_URL } from "@/constants";
import Alert from "../components/alert/alert.vue";

const TIMEOUT = 1000000;
const onRequestSuccess = (config) => {
  const token = localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken");
  if (token) {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.timeout = TIMEOUT;
  config.url = `${SERVER_API_URL}${config.url}`;
  return config;
};
const setupAxiosInterceptors = (onUnauthenticated) => {
  const onResponseError = (err) => {
    const status = err.status || (err.response && err.response.status);

    if (err.response && (err.response.status === 401 || err.response.status === 403)) {
      // Redirection vers la page d'erreur spécifique
      if (err.response.data === "MULTIPLE_CONNEXION") {
        window.location.replace(window.origin + "/platform#multi-connexion");
      } else if (err.response.data === "CHANGE_ROLE") {
        window.location.replace(window.origin + "/platform#change-role");
      } else if (err.response.data === "CONNEXION_NOT_PRESENT") {
        window.location.replace(window.origin + "/platform#connexion-not-present");
      } else if (err.response.data === "USER_DEACTIVATED") window.location.replace(window.origin);
    }

    return Promise.reject(err);
  };
  if (axios.interceptors) {
    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use((res) => res, onResponseError);
  }
};

export { onRequestSuccess, setupAxiosInterceptors };
